import React                     from 'react';
import { Observe }               from 'rewire-core';
import { WithStyle }             from 'rewire-ui';
import { Theme }                 from '@material-ui/core/styles';
import Breadcrumbs               from './Breadcrumbs';
import { withStyles }            from '../utility/styles';

const styles = (_theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: '0 0 auto',
    flexWrap: 'wrap',
  },
});

interface IMainContentToolbarProps {
}

type MainContentToolbarProps = WithStyle<ReturnType<typeof styles>, IMainContentToolbarProps>;

class MainContentToolbar extends React.PureComponent<MainContentToolbarProps> {
  constructor(props: MainContentToolbarProps) {
    super(props);
  }

  render() {
    const {classes, children} = this.props;

    return <Observe render={() => (

      <div className={classes.root}>
        {children
          ? children
          : <Breadcrumbs />
        }
      </div>
    )} />;
  }
}

export default withStyles<IMainContentToolbarProps>(styles, MainContentToolbar);
